import Constants from "data/Constants";
import React, { useEffect, useState } from "react";
import {
  IoNotificationsCircle,
  IoNotificationsOffCircle,
} from "react-icons/io5";
import { useOutletContext } from "react-router-dom";
import { getAdminNotifications } from "services/notification.service";
import Utils from "utils";

function AdminNotification({ limit = null }) {
  const [data, setData] = useState([]);
  const { setProgress, setToast, isRefreshed } = useOutletContext();

  useEffect(() => {
    setProgress(true);

    async function api() {
      try {
        const data = await getAdminNotifications();
        if (data) {
          setData(data);
          setProgress(false);
        } else {
          // error
          setProgress(false);
          setToast({ error: true, message: Constants.Error.UNKNOWN });
        }
      } catch (error) {
        // error

        setProgress(false);
        setToast({
          error: true,
          message: Utils.CustomErrorMessage(error),
        });
      }
    }
    api();
  }, [isRefreshed]);

  return (
    <div>
      {data.length == 0 && (
        <div className="text-gray-400 text-sm flex items-center justify-center h-96 flex-col">
          <IoNotificationsOffCircle className="text-[8rem]" />
          <span>It looks like a new beginning!</span>
          <span> Any new notifications will appear here.</span>
        </div>
      )}
      {data.map((notification) => {
        return (
          <div className="flex p-3 gap-4 items-center bg-blue-100 rounded cursor-pointer shadow-sm">
            <div>
              <IoNotificationsCircle className="text-primary text-6xl" />
            </div>
            <div>
              <div className="font-bold text-sm">{notification.title}</div>
              <div className="text-xsm text-gray-600">
                {Utils.timeSince(notification.createdAt) + " ago"}
              </div>
              <div className="text-gray-600">{notification.message}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default AdminNotification;
